import React from "react";
import Card from "@components/cards/Card/Card";
import Button from "@components/buttons/Button/Button";
import styles from "@styles/CommonAuthPageLayout.module.css";
import CheckIcon from "@components/display/CheckIcon/CheckIcon";

const SignUpSuccessPage = () => {
    return (
        <div>
            <Card className={styles.cardContainer}>
                <div className={styles.linkContainer}>
                    <CheckIcon />
                    <p>Sign-up successful!</p>
                    <p>We&apos;ve sent you a verification email. Please check your inbox (and spam folder) to verify your account.</p>
                </div>
                <div className={styles.buttonLinkContainer}>
                    <Button
                        variant="primary"
                        to="/auth/sign-in"
                    >
                        Sign In
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default SignUpSuccessPage;
